import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading
} from '../../styles/account/account'
import { DashboardWrapper } from '../../container/dashboardWrapper'
import { Breadcrumb } from '../../components/breadcrumb/breadcrumb'
import { AvailableAssignments } from '../../components/available-assignments/available-assignments'
import { SubmittedAssignments } from '../../components/submitted-assignments/submitted-assignments'

const Assignments = () => {
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <Heading>
                            Assignments
                        </Heading>
                        <Breadcrumb
                            crumbs={['Assignments']}
                        />
                        <AvailableAssignments />
                        <SubmittedAssignments />
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default Assignments
